module.exports = __webpack_public_path__ + "img/HHdszorolap2024.ba8881ff.jpg";